import { useContext } from 'react'

import { AuthContext } from '../contexts/AuthContextProvider'
import { User, AuthContext as AuthContextType } from '../types'

export const useAuth = <T extends User>() => useContext( AuthContext ) as AuthContextType<T>